import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'adsLocations',
    standalone: true
})
export class AdsLocationsPipe implements PipeTransform {
    private readonly labels: Record<string, string> = {
        'RIGHT': 'Skyscraper Rechts',
        'LEFT': 'Skyscraper Links',
        'DASH': 'Dashboard Superbanner',
        'INVOICE_BANNER': 'Belegarchiv Footer',
        'FEATURED_BANNER': 'Featured Banner',
        'PROMO': 'Promotions Banner',
        'PRODUCT_SEARCH': 'Produktsuche Banner',
        'MENU': 'Square Banner',
        'STICKY_BANNER': 'Sticky Banner',
        'EMAIL_BANNER': 'Email Banner',
    };

    transform(value: string): string {
        return this.labels[value] || value;
    }
}



